import {
  MdLocalGasStation,
  MdBuild,
  MdNaturePeople,
  MdAcUnit,
  MdLightbulbOutline,
  MdAirlineSeatFlat,
  MdInvertColors,
  MdWbSunny,
  MdAddBox,
  MdExtension,
} from 'react-icons/md';
import { CardCategories } from '../../types/interfaces';

export const CATEGORY_SELECT_ITEMS: { value: string; label: string }[] = [
  { value: 'fuel_level_sensor', label: 'Контроль уровня топлива' },
  { value: 'mechanism_deviation_sensor', label: 'Контроль отклонения механизмов спец.техники' },
  { value: 'agricultural_technology_sensor', label: 'Контроль с/х техники' },
  { value: 'temperature_and_humidity_sensor', label: 'Контроль температуры и влажности' },
  { value: 'indicator', label: 'Индикаторы' },
  { value: 'axle_load_sensor', label: 'Контроль нагрузки на ось' },
  { value: 'liquid_level_sensor', label: 'Контроль уровня жидкостей' },
  { value: 'meteorological_equipment', label: 'Метеорологическое оборудование' },
  { value: 'accessories', label: 'Аксессуары' },
  { value: 'optional_equipment', label: 'Дополнительное оборудование' },
];

export const CATEGORY_ICONS_AND_COLORS: Record<
  CardCategories,
  { icon: typeof MdAddBox; color: string; label: string }
> = {
  [CardCategories.FUEL_LEVEL_SENSOR]: { icon: MdLocalGasStation, color: '#FF4500', label: 'Контроль уровня топлива' },
  [CardCategories.MECHANISM_DEVIATION_SENSOR]: { icon: MdBuild, color: '#1E90FF', label: 'Контроль отклонения механизмов спец.техники' },
  [CardCategories.AGRICULTURAL_TECHNOLOGY_SENSOR]: { icon: MdNaturePeople, color: '#008000', label: 'Контроль с/х техники' },
  [CardCategories.TEMPERATURE_AND_HUMIDITY_SENSOR]: { icon: MdAcUnit, color: '#FF8C00', label: 'Контроль температуры и влажности' },
  [CardCategories.INDICATOR]: { icon: MdLightbulbOutline, color: '#FF8C00', label: 'Индикаторы' },
  [CardCategories.AXLE_LOAD_SENSOR]: { icon: MdAirlineSeatFlat, color: '#FF4500', label: 'Контроль нагрузки на ось' },
  [CardCategories.LIQUID_LEVEL_SENSOR]: { icon: MdInvertColors, color: '#FF4500', label: 'Контроль уровня жидкостей' },
  [CardCategories.METEOROLOGICAL_EQUIPMENT]: { icon: MdWbSunny, color: '#FF4500', label: 'Метеорологическое оборудование' },
  [CardCategories.ACCESSORIES]: { icon: MdExtension, color: '#696969', label: 'Аксессуары' },
  [CardCategories.OPTIONAL_EQUIPMENT]: { icon: MdAddBox, color: '#FF4500', label: 'Дополнительное оборудование' },
  [CardCategories.NO_CATEGORY]: { icon: MdAddBox, color: '#A9A9A9', label: 'Без категории' },
};
